/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

export const columns: TableColumn[] = [
    {
        Header: "tableCommon.sl_no",
        accessor: "slno",
    },
    {
        Header: "tableCommon.batch_code",
        accessor: "batch_number",
    },
     {
        Header: "plateInventory.tableColumns.manufacture_details",
        accessor: "manufacturer_details",
    },
    {
        Header: "plateInventory.tableColumns.manufacture_date",
        accessor: "manufacture_date",
    },
    {
        Header: "plateInventory.tableColumns.expiry_date",
        accessor: "expiry_date",
    },
    {
        Header: "plateInventory.tableColumns.total_quantity",
        accessor: "quantity",
    },
    {
        Header: "plateInventory.tableColumns.volume",
        accessor: "capacity",
    },
    {
        Header: "plateInventory.tableColumns.used_volume",
        accessor: "remaining_quantity",
    },
    // {
    //     Header: "Test Tube Type",
    //     accessor: "plate_type",
    // },
    // {
    //     Header: "plateInventory.tableColumns.status",
    //     accessor: "status",
    // },
  ];

  export const columnsByBatch: TableColumn[] = [
    {
        Header: "tableCommon.sl_no",
        accessor: "slno",
    },
    // {
    //     Header: "Batch Code",
    //     accessor: "batch_number",
    // },
    {
        Header: "tableCommon.seriel_number",
        accessor: "serial_number",
    },
    {
        Header: "plateInventory.tableColumns.manufacture_date",
        accessor: "manufacturing_date",
    },
    {
        Header: "plateInventory.tableColumns.expiry_date",
        accessor: "expiry_date",
    },
    {
        Header: "plateInventory.tableColumns.status",
        accessor: "status",
    },
  ];


  export const BatchWiseReconcilationColums: TableColumn[] = [
    {
      Header: 'Sl.No',
      accessor: 'slno',
    },
    {
      Header: 'tableCommon.batch_code',
      accessor: 'batch_code',
    },
    // {
    //   Header: 'Lot Count',
    //   accessor: 'lot_count',
    // },
    {
      Header: 'Saline Tube Count',
      accessor: 'plates_available',
    },
    {
      Header: 'Total Capacity',    
      accessor: 'total_capacity',
    },
    {
      Header: 'Remaining Capacity',    
      accessor: 'used_capacity',
    },
    // {
    //   Header: 'Saline Tube Used Count',    
    //   accessor: 'plates_used_',
    // },
    // {
    //   Header: 'Remaining Saline Tube Count',    
    //   accessor: 'remaining_plates_reconciliation_',
    // },
  ]

  interface TableColumn {
    Header: string;
    accessor: string;
  }
